import { HTTP_METHODS } from '@studio/constants/axios';
import { STREAM_USAGE_API_V1 } from '@studio/constants/env-variables';
import type { StreamUsage } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${STREAM_USAGE_API_V1}/customers/@customerId/streams/type`,
    query: {} as {
      endDate: string;
      startDate: string;
      trial?: boolean;
      type: StreamUsage.Derived.StreamUsageType;
    },
    response: {} as StreamUsage.Get.StreamType[],
    method: HTTP_METHODS.GET,
  },
};
